// METIS Hub wording — namespace "stats" (ko), 382 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/stats.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const stats: Record<string, string> = {
  "stats.kicker.me": "내 통계",
  "stats.kicker.team": "우리 팀 · {team}",
  "stats.kicker.all": "회사 전체",
  "stats.kicker.allTeam": "전체 · {team}만",
  "stats.kicker.view": "저장한 보기",
  "stats.title": "{item} 통계",
  "stats.desc": "{range} · 한국 시간 · 기준 {asof}",
  "stats.tabs": "통계 항목",
  "stats.loading": "조건을 맞추고 있어요",
  "stats.cond.tool": "도구",
  "stats.cond.toolAll": "모든 도구",
  "stats.cond.model": "AI 모델",
  "stats.cond.modelAll": "모든 AI 모델",
  "stats.cond.button": "조건",
  "stats.cond.buttonN": "조건 {n}",
  "stats.cond.title": "조회 조건",
  "stats.cond.clear": "조건 지우기",
  "stats.cond.cleared": "조건을 지웠어요",
  "stats.cond.applied": "조건을 적용했어요",
  "stats.cond.modelNote": "AI 모델 조건은 그 모델을 쓴 대화를 골라요.",
  "stats.cond.scope": "이 카드 범위: {scope}",
  "stats.small.title": "소집단 보호가 켜져 있어요",
  "stats.small.body": "조건에 남은 사람이 {n}명이라 시간대·AI 사용 시간·사람별 값을 가렸어요(본인 기록은 예외).",
  "stats.small.threshold": "선택한 조건이 최소 {n}명의 소집단 보호 기준을 충족하지 않아 시간대·AI 사용 시간·사람별 값을 가렸어요(본인 기록은 예외).",
  "stats.small.more": "소집단 보호란?",
  "stats.smallTeams": "소규모 팀 합산",
  "stats.total": "합계",
  "stats.bar.open": "누르면 이 기간의 사용 기록을 열어요",
  "stats.overall": "전체 기간",
  "stats.col.when": "시각",
  "stats.cell.none": "기록 없음",
  "stats.sample.few": "표본 부족",
  "stats.views.button": "저장한 보기",
  "stats.views.title": "저장한 보기",
  "stats.views.none": "아직 직접 저장한 보기가 없어요.",
  "stats.views.sample": "예시",
  "stats.views.mine": "내가 만든 보기",
  "stats.views.share": "주소로 나누면 받는 사람의 권한·보기 범위로 다시 판단해요. 만든 사람만 목록에서 보고 고쳐요.",
  "stats.views.save": "현재 보기 저장",
  "stats.views.saveTitle": "현재 보기를 저장할까요?",
  "stats.views.saveLead": "항목 탭(또는 카드 목록)·카드 옵션·공통 조건·보기 범위를 함께 남겨요. 기간은 ‘최근 30일’처럼 상대값으로 저장해요.",
  "stats.views.name": "보기 이름",
  "stats.views.namePh": "예: 주간 팀 리포트",
  "stats.views.nameErr": "보기 이름을 적어 주세요.",
  "stats.views.saved": "‘{name}’ 보기를 저장했어요",
  "stats.views.what": "저장할 것: {what}",
  "stats.views.delete": "지우기",
  "stats.views.deleteTitle": "이 보기를 지울까요?",
  "stats.views.deleteBody": "‘{name}’ 보기만 지워요. 기록이나 다른 사람의 보기는 그대로예요.",
  "stats.views.deleted": "보기를 지웠어요",
  "stats.views.cards": "카드 {n}개",
  "stats.views.tab": "{item} 탭",
  "stats.views.sum": "{what} · {period} · {scope}",
  "stats.views.cond": "{period} · {scope}",
  "stats.view.close": "보기 닫기",
  "stats.view.missing": "이 저장한 보기를 찾지 못했어요. 만든 사람만 열 수 있어요.",
  "stats.view.scopeDown": "보기 범위를 ‘{scope}’ 범위로 열었어요. 받는 사람의 권한으로 다시 판단해요.",
  "stats.view.hidden": "권한이 없어 일부 카드를 숨겼어요({n}개).",
  "stats.view.edited": "이 보기에서 바꾼 옵션은 [현재 보기 저장]으로 새 보기에 남길 수 있어요.",
  "stats.seed.weekly": "주간 팀 리포트",
  "stats.seed.codex": "내 Codex 사용",
  "stats.addView.title": "저장한 보기에 추가",
  "stats.addView.lead": "이 카드와 지금 옵션을 보기에 넣어요. 여러 항목의 카드를 한 보기에 모을 수 있어요.",
  "stats.addView.pick": "넣을 보기",
  "stats.addView.new": "새 보기 만들기",
  "stats.addView.newName": "새 보기 이름",
  "stats.addView.defaultName": "내 통계 모음",
  "stats.addView.added": "‘{name}’에 이 카드를 넣었어요",
  "stats.addView.updated": "‘{name}’에 이미 있는 카드라 옵션만 바꿨어요",
  "stats.addView.sampleNote": "예시 보기는 바꿀 수 없어요. 내가 만든 보기나 새 보기에 넣어요.",
  "stats.addView.add": "넣기",
  "stats.export.title": "이 카드 내보내기",
  "stats.export.lead": "카드의 표를 그대로 받아요. 기본은 가명·글 제외이고, 받으면 열람·변경 이력에 남아요.",
  "stats.export.fmt": "형식",
  "stats.export.preview": "미리보기(앞부분)",
  "stats.export.rows": "표 {n}행 · 머리말 포함 · 서버에 파일을 남기지 않아요",
  "stats.export.get": "받기",
  "stats.export.done": "내보냈어요. 열람·변경 이력에 남았어요.",
  "stats.export.none": "내보낼 숫자가 없어요.",
  "stats.export.noPerm": "이 보기 범위를 내보낼 권한이 없어요",
  "stats.export.h1": "METIS Hub 통계 내보내기 · {id}",
  "stats.export.h2": "만든 사람 역할: {role} · {time}(한국 시간)",
  "stats.export.h3": "카드: {q}({card}) · 지표 사전 v1",
  "stats.export.h4": "조건: {cond} · 보기 범위: {scope}",
  "stats.export.h5": "금지 용도: 사용 통계는 비용·보안 관리를 위한 것이며 근무·성과 평가에 쓰지 않아요 · 기록 없음 ≠ 안 씀",
  "stats.export.h6": "가림: 사람 이름은 권한 밖이면 가명, 질문·답변 글은 넣지 않아요 · 사람이 3명보다 적은 칸은 <3",
  "stats.opt.by": "비교 기준",
  "stats.opt.bars": "막대 기준",
  "stats.opt.metric": "지표",
  "stats.opt.agg": "집계 방식",
  "stats.opt.bucket": "묶음 단위",
  "stats.opt.scope": "보기 범위(이 카드)",
  "stats.opt.toggles": "표시",
  "stats.opt.periodHelp": "이 카드만 기간을 바꿔요. 공통 기간과 다르면 카드 머리에 ‘이 카드만’ 칩이 떠요.",
  "stats.opt.aggHelp": "개수·사용량은 합계·1인당, 길이·시간은 보통·평균으로 계산해요. 1인당 = 합계 ÷ 그 계열에 기록이 있는 사람 수.",
  "stats.opt.scopeHelp": "파일 카드는 기본으로 ‘나’ 범위예요. 넓혀도 폴더 이름은 파일 보기 권한이 있고 3명 이상일 때만 보여요.",
  "stats.opt.topHelp": "도넛은 늘 5조각 + 기타예요.",
  "stats.opt.prevHelp": "같은 길이의 바로 앞 기간 합계를 점선으로 겹쳐요.",
  "stats.opt.hide0": "0인 날 숨기기",
  "stats.opt.hide0.desc": "확인된 0만 숨겨요. 기록 없음 구간은 늘 보여요.",
  "stats.opt.split": "열어 봄·고침 나눠 보기",
  "stats.opt.split.desc": "확장자마다 열어 본 파일과 고친 파일을 나눠 쌓아요.",
  "stats.opt.splitTool": "도구별로 나눠 보기",
  "stats.opt.splitTool.desc": "작업 종류마다 Claude Code·Codex 몫을 나눠 쌓아요.",
  "stats.opt.unoff": "비공식 추정 보기(Codex)",
  "stats.opt.unoff.desc": "공식 문서에 없는 값이라 기본으로 접어 둬요.",
  "stats.opt.reset": "쓸 수 없거나 권한 밖인 옵션은 기본값으로 열었어요.",
  "stats.opt.hourClamp": "시간 단위는 기간이 7일 이하일 때만 써서 ‘일’로 그렸어요.",
  "stats.bucket.auto": "자동",
  "stats.bucket.hour": "시간",
  "stats.bucket.day": "일",
  "stats.bucket.week": "주",
  "stats.bucket.month": "월",
  "stats.bucket.help": "한국 시간 기준, 주는 월요일에 시작해요. 시간 단위는 기간이 7일 이하일 때만 써요.",
  "stats.agg.sum": "합계",
  "stats.agg.perPerson": "1인당",
  "stats.agg.avg": "평균",
  "stats.agg.p50": "보통",
  "stats.agg.p95": "느릴 때",
  "stats.disp.auto": "자동",
  "stats.disp.raw": "토큰",
  "stats.disp.k": "천",
  "stats.disp.man": "만",
  "stats.disp.m": "백만",
  "stats.chart.stackedBar": "누적 막대",
  "stats.chart.bar": "막대",
  "stats.chart.line": "선",
  "stats.chart.stackedArea": "누적 영역",
  "stats.chart.table": "표",
  "stats.chart.heatmap": "히트맵",
  "stats.chart.donut": "도넛",
  "stats.chart.hbar": "가로 막대",
  "stats.chart.histogram": "분포 막대",
  "stats.chart.pct100": "100% 막대",
  "stats.chart.diverging": "막대(추가 위·삭제 아래)",
  "stats.by.kind": "사용량 종류",
  "stats.by.dis": "{label} — {reason}",
  "stats.by.cliOnly": "CLI 도구에만 있어요",
  "stats.audit.export": "통계 · {card} · {fmt} {n}행(가명·글 제외)",
  "stats.chip.prev": "직전 기간 비교",
  "stats.chip.prevOff": "직전 기간 끔",
  "stats.chip.hide0": "0인 날 숨김",
  "stats.chip.top": "상위 {n}",
  "stats.chip.more": "외 {n}개",
  "stats.m.perConv": "대화당 질문 수",
  "stats.m.lines": "추가·삭제 줄",
  "stats.m.commits": "커밋·PR 수",
  "stats.m.failRate": "실패율",
  "stats.m.latency": "응답 대기(보통·느릴 때)",
  "stats.m.tokens4": "사용량 4종",
  "stats.m.costAs": "비용 환산 · {kind}",
  "stats.m.filesByExt": "확장자별 파일 수",
  "stats.m.linesByExt": "확장자별 추가·삭제 줄(Codex)",
  "stats.m.tokensShare": "사용량 비중",
  "stats.m.promptsShare": "질문 비중",
  "stats.m.costShare": "비용 비중 · {kind}",
  "stats.m.apiTokens": "사용량(API 키 호출)",
  "stats.m.errorKinds": "AI 호출 오류·도구 실패",
  "stats.m.errors": "요청 실패·응답 거부",
  "stats.m.rejects": "도구 거절",
  "stats.kind.in": "새로 읽음",
  "stats.kind.outEx": "AI가 쓴 양(생각 뺀 몫)",
  "stats.kind.reason": "생각에 쓴 양(쓴 양에 포함)",
  "stats.kind.reasonCol": "그중 생각에 쓴 양(더하지 않음)",
  "stats.kind.added": "추가 줄",
  "stats.kind.removed": "삭제 줄",
  "stats.codexEst": "Codex(추정)",
  "stats.commits": "커밋",
  "stats.prs": "PR",
  "stats.person.sum": "{n}명의 {metric}{eul} 이름순으로 보여요(순위 아님).",
  "stats.person.not": "사람 기준 비교를 쓸 수 없다는 뜻이에요. 팀·전체 합계는 그대로 볼 수 있어요.",
  "stats.empty.cond.not": "다른 조건에서는 기록이 있을 수 있어요.",
  "stats.empty.cond.next": "조건 풀기",
  "stats.empty.connect": "도구 연결하기",
  "stats.empty.wider": "{p}로 넓히기",
  "stats.empty.small.what": "사람이 3명보다 적어 이 그림을 숨겼어요.",
  "stats.empty.small.not": "기록이 없다는 뜻이 아니에요. 누구인지 짐작되지 않게 하려는 거예요. 기간이나 팀 범위를 넓혀 보세요.",
  "stats.empty.small.next": "기간을 90일로 넓히기",
  "stats.empty.small.allTeams": "모든 팀으로 넓히기",
  "stats.empty.level.what": "작업 상세(파일 경로)를 남기는 사람의 기록이 없어요.",
  "stats.empty.level.not": "파일 작업이 없었다는 뜻이 아니에요. 기록 수준 ④(작업 상세)를 고른 사람만 세요.",
  "stats.empty.level.next": "기록 수준 안내",
  "stats.empty.codexActive.what": "Codex는 AI 사용 시간을 보내지 않아요.",
  "stats.empty.codexActive.not": "Codex를 안 썼다는 뜻이 아니에요.",
  "stats.empty.support": "지원표 보기",
  "stats.empty.gw.what": "게이트웨이를 거친 호출만 사람별로 보여요.",
  "stats.empty.gw.not": "API 키를 안 썼다는 뜻이 아니에요.",
  "stats.empty.gw.next": "앱 연결 방법",
  "stats.empty.cliOnly.what": "사용 방식 조건이 ‘CLI 도구’라 API 키 호출이 빠졌어요.",
  "stats.empty.apiOnly.what": "사용 방식 조건이 ‘API 키 호출’이라 이 카드에 해당하는 기록이 없어요.",
  "stats.empty.apiOnly.not": "API 키 호출에는 파일·바뀐 내용·AI가 한 작업·AI 사용 시간이 없어요(이 사용 방식엔 해당 없음).",
  "stats.empty.perConvApi": "API 키 호출은 대화가 없어 대화당 질문 수를 셀 수 없어요.",
  "stats.empty.commits.what": "커밋·PR 수는 Claude Code 숫자 지표에서만 와요.",
  "stats.c.promptsTrend.q": "AI에게 몇 번 물어봤나요?",
  "stats.c.promptsTrend.qPerson": "사람별로 몇 번 물어봤나요?",
  "stats.c.promptsTrend.tech": "{metric} · {by}별 {chart}",
  "stats.c.promptsTrend.techPerson": "{metric} · 사람 · 이름순(순위 아님)",
  "stats.c.promptsTrend.def": "/로 시작하는 명령은 빼고 센 질문 건수예요. API 키 호출은 호출 1번을 질문 1번으로 세요(호출 수).",
  "stats.c.promptsTrend.formula": "질문 수 = 질문 이벤트 수(/명령 제외) · 대화당 질문 수 = 대화 하나의 질문 수(보통·평균)",
  "stats.c.promptsTrend.sum": "{p} 동안 AI에게 {n}번 물어봤어요.",
  "stats.c.promptsTrend.sumPer": "{p} 동안 1인당 {v}번 물어봤어요({total}번 ÷ {people}명).",
  "stats.c.promptsTrend.sumSlash": "{p} 동안 /명령을 {n}번 썼어요.",
  "stats.c.promptsTrend.sumSlashPer": "{p} 동안 1인당 /명령을 {v}번 썼어요({total}번 ÷ {people}명).",
  "stats.c.promptsTrend.sumLen": "질문 길이는 {how} {v}예요(질문 {n}건).",
  "stats.c.promptsTrend.sumConv": "대화 하나에서 {how} {v}번 물어봤어요(대화 {n}개).",
  "stats.c.promptsTrend.apiNote": "API 키 호출은 호출 1번을 질문 1번으로 세요(호출 수).",
  "stats.how.p50": "보통",
  "stats.how.avg": "평균",
  "stats.c.promptsHeat.q": "언제 많이 물어보나요?",
  "stats.c.promptsHeat.tech": "요일 × 시간 · 질문 보낸 시각(한국 시간)",
  "stats.c.promptsHeat.sum": "{wd}요일 {h} 무렵에 가장 많이 물어봤어요({n}건).",
  "stats.c.promptsHeat.note": "매니저·관리자도 시간대는 합계로만 봐요. 사람이 3명보다 적으면 가려요.",
  "stats.col.weekday": "요일",
  "stats.c.usageTrend.q": "사용량이 어떻게 변했나요?",
  "stats.c.usageTrend.techKind": "사용량(토큰) · 종류별 {chart} · 생각에 쓴 양은 점 무늬(더하지 않음)",
  "stats.c.usageTrend.techBy": "사용량(토큰) · {by}별 {chart}",
  "stats.c.usageTrend.techCost": "비용 환산 · {kind} · {by}별 {chart}",
  "stats.c.usageTrend.formula": "사용량 = 새로 읽음 + 캐시에서 읽음 + 캐시에 저장 + AI가 쓴 양(생각 포함). Codex는 캐시에 저장을 쌓지 않아요(3종).",
  "stats.c.usageTrend.sum": "{p} 사용량은 {v}{ie}.",
  "stats.c.usageTrend.sumCost": "{p} {kind} 비용은 {v}{ie}.",
  "stats.c.usageTrend.reasonNote": "생각에 쓴 양 {v}은 AI가 쓴 양 안에 들어 있어 합계에 더하지 않아요.",
  "stats.c.usageTrend.reasonNone": "생각에 쓴 양:",
  "stats.c.usageTrend.perNote": "1인당 = 합계 ÷ 이 조건에 기록이 있는 사람 {n}명",
  "stats.c.usageTrend.sumPer": "{p} 1인당 사용량은 {v}예요(기록이 있는 사람 {n}명 기준).",
  "stats.opt.topTrend": "그림은 색 5개 + 기타까지 나누고, 표로 보기에는 상위 N개가 모두 있어요.",
  "reasonDetail.no_gateway": "게이트웨이를 거치지 않은 키라 우리 쪽 단가표 계산 값이 없어요",
  "reasonDetail.no_org": "조직 보고서에 아직 없는 날·키예요(보고서는 하루 단위로 늦게 와요)",
  "reasonDetail.no_compare": "한쪽 값이 없어 차이를 계산하지 않았어요",
  "stats.c.usageTrend.codexNote": "Codex ‘캐시에 저장’은 입력에 들어 있는지 확인하기 전이라 쌓지 않아요.",
  "stats.c.usageTrend.costNote": "비용 종류가 다르면 서로 더하지 않아요. 종류 하나를 골라 그 금액으로 바꿔 보여요.",
  "stats.c.usageTop.q": "어떤 모델·도구가 많이 썼나요?",
  "stats.c.usageTop.qPerson": "사람별로 얼마나 썼나요?",
  "stats.c.usageTop.tech": "{metric} · {by}별 상위 {n} + 기타",
  "stats.c.usageTop.techRatio": "캐시 다시 쓴 비율 · {by}별 상위 {n}",
  "stats.c.usageTop.techPerson": "사용량(토큰) · 사람 · 이름순(순위 아님)",
  "stats.c.usageTop.formula": "캐시 다시 쓴 비율 = 캐시에서 읽음 ÷ (새로 읽음 + 캐시에서 읽음 + 캐시에 저장)",
  "stats.c.usageTop.sum": "사용량의 {pct}가 {name}에서 나왔어요({v}/{total}).",
  "stats.c.usageTop.sumRatio": "{name}의 캐시 다시 쓴 비율이 {pct}로 가장 높아요.",
  "stats.c.usageTop.readOf": "읽은 양 {v} 중",
  "stats.kpi.total": "사용량(토큰) 합계",
  "stats.kpi.totalHint": "사용량 합계 · 생각에 쓴 양은 더하지 않음(Codex는 3종)",
  "stats.kpi.ratio": "캐시 다시 쓴 비율",
  "stats.kpi.ratioHint": "캐시에서 읽음 {a} ÷ 읽은 양 {b}",
  "stats.kpi.reason": "생각에 쓴 양(포함)",
  "stats.kpi.reasonHint": "AI가 쓴 양 {out} 안에 들어 있어요",
  "stats.kpi.cost": "CLI 도구 추정 비용",
  "stats.kpi.costHint": "추정 · 청구서 아님 · 단가표 계산 {b}는 따로",
  "stats.c.filesExt.q": "AI가 어떤 종류의 파일을 다뤘나요?",
  "stats.c.filesExt.tech": "{metric} · 확장자별 · {chart}",
  "stats.c.filesExt.techSplit": "확장자별 열어 봄·고침 · 가로 막대",
  "stats.c.filesExt.def": "기록 수준 ④(작업 상세)에서 AI 도구가 보고한 파일 작업만 세요.",
  "stats.c.filesExt.sum": "{ext} 파일이 {pct}로 가장 많아요({v}/{total}개).",
  "stats.c.filesExt.note": "AI 도구가 보고한 작업만 기록해요. 셸 명령으로 연 파일은 빠질 수 있어요.",
  "stats.c.filesExt.read": "열어 봄",
  "stats.c.filesExt.edited": "고침",
  "stats.c.filesFolders.q": "자주 다룬 폴더는 어디인가요?",
  "stats.c.filesFolders.tech": "폴더별 파일 수 · 경로 마지막 두 단계 · 상위 {n} + 기타",
  "stats.c.filesFolders.sum": "가장 많이 다룬 폴더는 {name}{ie}({v}개).",
  "stats.c.filesFolders.sumHidden": "폴더 {n}곳에서 파일을 다뤘어요. 폴더 이름은 권한이 있어야 보여요.",
  "stats.c.filesFolders.hidden": "폴더 이름은 파일 보기 권한이 있고 사람이 3명 이상일 때만 보여요.",
  "stats.col.folder": "폴더",
  "stats.col.ext": "확장자",
  "stats.c.changesLines.q": "코드가 얼마나 바뀌었나요?",
  "stats.c.changesLines.tech": "추가·삭제 줄 · 도구별 · 추가는 위, 삭제는 아래",
  "stats.c.changesLines.techOther": "{metric} · 도구별 {chart}",
  "stats.c.changesLines.def": "AI 기여율이 아니에요. Claude Code는 숫자 지표, Codex는 패치에서 센 추정이에요.",
  "stats.c.changesLines.sum": "{p} 동안 Claude Code가 {a}줄을 더하고 {r}줄을 지웠어요.",
  "stats.c.changesLines.sumCodex": "Codex는 패치에서 센 추정으로 {a}줄을 더하고 {r}줄을 지웠어요.",
  "stats.c.changesLines.sumCount": "{p} 동안 {metric}{eun} {n}{ie}.",
  "stats.c.changesLines.sumCommits": "{p} 동안 커밋 {c}개, PR {r}개가 남았어요.",
  "stats.c.changesLines.metricsOff": "Claude Code 숫자 지표 보내기가 꺼진 기록 {n}건은 줄 수가 없어요.",
  "stats.c.changesLines.refetch": "설정 다시 받기",
  "stats.c.changesLines.axis": "위: 추가 줄 · 아래: 삭제 줄",
  "stats.c.changesLines.noPerson": "사람 기준으로 나누지 않아요.",
  "stats.c.changesExt.q": "어떤 종류의 파일이 많이 바뀌었나요?",
  "stats.c.changesExt.tech": "확장자별 고친 파일 수 · 상위 {n} + 기타",
  "stats.c.changesExt.techLines": "확장자별 추가·삭제 줄 · Codex만(패치 계산 추정)",
  "stats.c.changesExt.def": "셸 명령으로 바꾼 파일과 파일 전체 비교(diff)는 기록할 수 없어요.",
  "stats.c.changesExt.sum": "고친 파일 가운데 {ext}{ga} {pct}로 가장 많아요({v}/{total}개).",
  "stats.c.changesExt.sumLines": "Codex가 {ext} 파일에서 가장 많이 바꿨어요(+{a} / −{r}줄).",
  "stats.c.timeActive.q": "AI를 얼마나 오래 썼나요?",
  "stats.c.timeActive.tech": "AI 사용 시간(Claude만) · {by} · {chart}",
  "stats.c.timeActive.sum": "{p} AI 사용 시간은 {v}{ie}.",
  "stats.c.timeActive.sumPer": "{p} AI 사용 시간은 1인당 {v}{ie}({total} ÷ {people}명).",
  "stats.c.timeOpen.q": "대화는 얼마나 길었나요?",
  "stats.c.timeOpen.tech": "대화가 열려 있던 시간 · 6구간 분포",
  "stats.c.timeOpen.sum": "{bin} 대화가 가장 많았어요({n}개). 보통 {med} 동안 열려 있었어요.",
  "stats.col.bin": "열려 있던 시간",
  "stats.col.convs": "대화 수",
  "stats.bin.0": "5분 미만",
  "stats.bin.1": "5~15분",
  "stats.bin.2": "15~30분",
  "stats.bin.3": "30분~1시간",
  "stats.bin.4": "1~2시간",
  "stats.bin.5": "2시간 이상",
  "stats.binShort.0": "~5분",
  "stats.binShort.1": "5~15분",
  "stats.binShort.2": "15~30분",
  "stats.binShort.3": "30~60분",
  "stats.binShort.4": "1~2시간",
  "stats.binShort.5": "2시간~",
  "stats.c.timeWait.q": "답을 얼마나 기다렸나요?",
  "stats.c.timeWait.tech": "응답 대기 · 보통·느릴 때 · 성공한 요청만",
  "stats.c.timeWait.techBy": "응답 대기({agg}) · {by}별 · 성공한 요청만",
  "stats.c.timeWait.techFirst": "첫 글자까지 · 보통 · 성공한 요청만",
  "stats.c.timeWait.formula": "보통 = 절반이 이 시간 안에 끝나요(p50) · 느릴 때 = 100건 중 95건이 이 시간 안에 끝나요(p95)",
  "stats.c.timeWait.sum": "응답은 보통 {a}, 느릴 때 {b} 걸렸어요(요청 {n}건).",
  "stats.c.timeWait.sumFirst": "첫 글자는 보통 {a} 만에 왔어요(요청 {n}건).",
  "stats.c.timeWait.few": "요청이 적어({n}건) 보통·느릴 때를 계산하지 않았어요.",
  "stats.c.timeWait.approx": "31일보다 긴 기간은 구간별 건수로 계산한 근사값이에요.",
  "stats.c.timeWait.sample": "요청이 5건보다 적은 칸은 비워 두었어요(표본 부족).",
  "stats.approx": "근사",
  "stats.noun.tokens": "사용량",
  "stats.noun.prompts": "질문",
  "stats.noun.cost": "{kind} 비용",
  "stats.c.modelsShare.q": "어떤 AI 모델을 썼나요?",
  "stats.c.modelsShare.tech": "AI 모델 · {metric} · 5조각 + 기타",
  "stats.c.modelsShare.sum": "{metric}의 {pct}가 {model}에서 나왔어요({v}/{total}).",
  "stats.c.modelsShare.note": "CLI 도구·게이트웨이가 보낸 모델 이름이에요. 질문은 그 대화의 주 모델로 세요.",
  "stats.c.modelsTrend.q": "모델·생각 깊이는 어떻게 바뀌었나요?",
  "stats.c.modelsTrend.tech": "{metric} · {by}별 누적 막대",
  "stats.c.modelsTrend.sum": "{metric}의 {pct}가 {by} ‘{name}’{iess}({v}/{total}).",
  "stats.c.modelsTrend.note": "생각 깊이 값이 없는 요청은 ‘확인 안 됨’, API 키 호출은 ‘해당 없음’ 칸에 넣어요.",
  "stats.c.actionsKinds.q": "AI가 어떤 작업을 했나요?",
  "stats.c.actionsKinds.tech": "{metric} · 작업 종류별 상위 {n} + 기타",
  "stats.c.actionsKinds.techCmd": "명령 실행 수 · 도구별",
  "stats.c.actionsKinds.sum": "AI가 한 작업 {n}회 가운데 {kind}{ga} {pct}로 가장 많아요.",
  "stats.c.actionsKinds.sumFail": "작업 {n}회 가운데 {f}회가 실패했어요({pct}).",
  "stats.c.actionsKinds.sumCmd": "AI가 명령을 {n}번 실행했어요.",
  "stats.c.actionsKinds.note": "원래 도구 이름은 막대 이름에 마우스를 올리면 보여요. Codex는 도구 호출 기준으로 성공을 세요.",
  "stats.c.actionsKinds.failOf": "실패 {f}/{n}회",
  "stats.c.actionsDecisions.q": "허용·거절은 누가 했나요?",
  "stats.c.actionsDecisions.tech": "허용·거절 × 결정한 쪽 · 100% 막대",
  "stats.c.actionsDecisions.sum": "허용 {n}회 가운데 {pct}는 {actor}{ga} 정했어요({v}/{n}회).",
  "stats.c.actionsDecisions.sumNone": "이 조건에는 허용·거절 기록이 없어요.",
  "stats.c.actionsDecisions.n": "{n}회",
  "stats.c.actionsDecisions.note": "Codex의 묶음 실행은 결정 기록이 없어 ‘주체 기록 없음’으로 세요.",
  "stats.c.actionsErrors.q": "오류·거절·재시도는 얼마나 있었나요?",
  "stats.c.actionsErrors.tech": "{metric} · {by}별 {chart}",
  "stats.c.actionsErrors.sum": "{p} {metric}{eun} {n}건이에요.",
  "stats.c.actionsErrors.note": "Claude는 재시도 끝에 실패한 1건, Codex는 실패한 시도마다 세요. 그래서 합치지 않고 도구별로 나란히 보여요.",
  "stats.c.apiCalls.q": "API 키로 얼마나 불렀나요?",
  "stats.c.apiCalls.tech": "{metric} · {by}별 {chart} · 게이트웨이를 거친 호출",
  "stats.c.apiCalls.techLat": "응답 대기 · 보통·느릴 때 · 게이트웨이",
  "stats.c.apiCalls.sum": "{p} 동안 API 키로 {n}번 불렀어요.",
  "stats.c.apiCalls.sumTok": "{p} API 키 호출 사용량은 {v}{ie}.",
  "stats.c.apiCalls.gw": "CLI(게이트웨이 경유) {n}건 · 중복 확인 중 · 어느 합계에도 더하지 않아요",
  "stats.c.apiCalls.note": "게이트웨이를 거친 호출만 사람별로 보여요. 조직 보고서는 아래 카드에서 따로 봐요.",
  "stats.c.apiRec.q": "조직 보고서와 맞나요?",
  "stats.c.apiRec.qMe": "내 키의 조직 보고서는 어떤가요?",
  "stats.c.apiRec.qTeam": "우리 팀 키의 조직 보고서는 어떤가요?",
  "stats.c.apiRec.tech": "단가표 계산 ↔ 조직 청구 · 날짜 × AI 모델 × API 키",
  "stats.c.apiRec.techLim": "조직 보고서 · 하루 단위 · 사람별 아님",
  "stats.c.apiRec.sum": "{n}칸 가운데 일치 {a} · 작은 차이 {b} · 큰 차이 {c} · 우리 기록에 없음 {d} · 보고서에 없음 {e}{ie}.",
  "stats.c.apiRec.sumLim": "키 {k}개 · {days}일 · 사용량 {tok} · 청구 기준 {usd}",
  "stats.c.apiRec.limNote": "청구 대조는 비용 보기(전체) 권한이 있어야 보여요.",
  "stats.c.apiRec.note": "하루 단위 · 사람별 아님 · CLI 구독 사용은 대조 대상이 아니에요. 게이트웨이 전용 워크스페이스로 나누지 않으면 차이가 늘 남아요.",
  "stats.rec.when": "날짜 · AI 모델 · 키",
  "stats.rec.ours": "단가표 계산",
  "stats.rec.org": "조직 청구",
  "stats.rec.diff": "차이",
  "stats.rec.status": "상태",
  "stats.rec.key": "API 키",
  "stats.rec.ok": "일치",
  "stats.rec.small": "작은 차이",
  "stats.rec.big": "큰 차이",
  "stats.rec.noOurs": "우리 기록에 없음",
  "stats.rec.noOrg": "보고서에 없음",
  "stats.rec.more": "{n}행 더 보기",
  "stats.rec.less": "접기",
  "stats.rec.noKey": "키 묶음 제공 안 됨",
  "stats.c.apiCosts.q": "비용은 어디서 왔나요?",
  "stats.c.apiCosts.tech": "비용 종류별 · 나란히 · 서로 더하지 않음",
  "stats.c.apiCosts.sum": "{list}{ie}. 서로 더하지 않아요.",
  "stats.c.apiCosts.part": "{kind} 비용은 {v}",
  "stats.c.apiCosts.none": "이 조건에는 비용 기록이 없어요.",
  "stats.c.apiCosts.sub.cli_estimate": "추정 · 청구서 아님 · Claude Code가 보낸 금액",
  "stats.c.apiCosts.sub.unofficial": "비공식 추정 · Codex 자체 계산",
  "stats.c.apiCosts.sub.gateway_price": "게이트웨이 사용량 × 단가표 · 청구서 아님",
  "stats.c.apiCosts.sub.org_bill": "청구 기준 · 하루 단위 · 사람별 아님",
  "stats.c.apiCosts.unoffHidden": "비공식 추정(Codex)은 접어 두었어요. [옵션]에서 볼 수 있어요.",
  "stats.col.kind": "비용 종류",
  "stats.col.cost": "금액",
};

export default stats;
